var styles = {"spinner":"styles_spinner__QfGSj","pointsContainer":"styles_points-container__M2VZp","point":"styles_point__v0aoL","twinkle":"styles_twinkle__Qz-qM","inheritColor":"styles_inherit-color__uaOHl"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
